// extracted by mini-css-extract-plugin
export default {"container":"G2gucCY71AfC3SpFjCsy","heading":"Zr8HE44Q1U7pnddQiYhL","detail":"cnjkEFUbe4IRxkYOgWFR"};